export default "__VITE_ASSET__CulyZAUU__"